module.exports = __webpack_public_path__ + "static/media/RPR Cutter.1fd43016.jpg";